export function getSubscriptionEnabledCityIds(): number[] {
  const raw = useRuntimeConfig().public.subscriptionEnabledCities
  return String(raw ?? '').split(',').map(s => Number(s.trim())).filter(Boolean)
}
